import type { ExpressionSpecification } from "maplibre-gl";
import { FEMA_MSC, fillLayers, pick, type LayerStyle } from "./types";

// FEMA convention: 1% annual chance zones (A, AE, AH, AO) blue, the 0.2% "shaded X" a lighter
// teal-blue; floodways purple. Unshaded X (minimal hazard) is not drawn.
const SFHA = "#3b6ff0";
const FLOODWAY = "#9b59d0";
const SHADED_X = "#18899c";

const color: ExpressionSpecification = [
  "case",
  ["==", ["get", "ZONE_SUBTY"], "FLOODWAY"], FLOODWAY,
  ["in", ["get", "FLD_ZONE"], ["literal", ["A", "AE", "AH", "AO", "A99", "VE", "V"]]], SFHA,
  SHADED_X,
];

const SUBTYPE: Record<string, string> = {
  FLOODWAY: "Regulatory floodway",
  "0.2 PCT ANNUAL CHANCE FLOOD HAZARD": "0.2% annual chance (500-year)",
  "AREA OF MINIMAL FLOOD HAZARD": "Minimal flood hazard",
};

const style: LayerStyle = {
  id: "fema-nfhl",
  minzoom: 9,
  maxzoom: 15,
  layers(source) {
    return fillLayers(this, source, color).map((l) => ({
      ...l,
      // Only hazard areas: drop unshaded X, which covers most of the metro.
      filter: ["any", ["==", ["get", "SFHA_TF"], "T"], ["==", ["get", "ZONE_SUBTY"], "0.2 PCT ANNUAL CHANCE FLOOD HAZARD"]],
    }));
  },
  legend: [
    { label: "Zone A / AE / AO: 1% annual chance (100-year)", color: SFHA },
    { label: "Regulatory floodway", color: FLOODWAY },
    { label: "Shaded X: 0.2% annual chance (500-year)", color: SHADED_X },
  ],
  describe: (p) =>
    pick(p, [
      ["FLD_ZONE", "Flood zone"],
      ["ZONE_SUBTY", "Zone subtype", (v) => SUBTYPE[String(v)] ?? String(v)],
      ["SFHA_TF", "Special flood hazard area", (v) => (v === "T" ? "Yes" : "No")],
      ["STATIC_BFE", "Base flood elevation (ft)", (v) => (Number(v) > -9000 ? String(v) : "")],
      ["DEPTH", "Flood depth (ft)", (v) => (Number(v) > -9000 ? String(v) : "")],
    ]).filter((f) => f.value !== ""),
  links: [FEMA_MSC],
};

export default style;
